/*
 * � 2020 Microsoft. All rights reserved.
 */

define ('util/dictionary',[],function () {

    var Dictionary = function (keyClass, valueClass) {
        this.initDictionary(keyClass, valueClass);
    };

    Dictionary.prototype.initDictionary = function (keyClass, valueClass) {
        this.keyClass = keyClass;
        this.valueClass = valueClass;
        this.keys = [];
        this.values = [];
    };

    Dictionary.prototype.Add = function (key, value) {
        var index = this.keys.indexOf(key);
        if (index != -1) {
            this.values[key] = value;
        }
        else {
            this.keys.push(key);
            this.values.push(value);
        }
    };

    Dictionary.prototype.Get = function (key) {
        var index = this.keys.indexOf(key);
        if (index != -1) {
            return this.values[index];
        }
        return null;
    };

    Dictionary.prototype.ContainsKey = function (key) {
        return this.keys.indexOf(key) != -1;
    };

    Dictionary.prototype.Clear = function () {
        this.keys = [];
        this.values = [];
    };

    Dictionary.prototype.GetKeys = function () {
        return this.keys;
    };

    Dictionary.prototype.GetValues = function () {
        return this.values;
    };

    return Dictionary;


});
